// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountRelationModel {
    static getAttributeTypeMap() {
        return AccountRelationModel.attributeTypeMap;
    }
}
AccountRelationModel.discriminator = undefined;
AccountRelationModel.attributeTypeMap = [
    {
        "name": "relatedId",
        "baseName": "relatedId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    }
];
//# sourceMappingURL=accountRelationModel.js.map